import { useContext } from 'react'
import { ToastContext } from '../contexts/ToastContext'

/**
 * useToast Hook
 * Provides easy access to toast methods throughout the app
 *
 * Usage:
 * const { success, error, warning, info } = useToast()
 *
 * success("Operation completed!")
 * error("Something went wrong")
 * warning("Please be careful")
 * info("Just so you know...")
 */
export function useToast() {
  const context = useContext(ToastContext)

  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }

  return context
}
